import {
    Flex,
    IconButton,
    ListItem,
    Text,
    UnorderedList,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiRequest } from "utils/api";
import UserAvatar from "../UserAvatar";
import WidgetBox from "../WidgetBox/widget-box";

const YourTeam = () => {
    const [contacts, setContacts] = useState<any[]>([]);
    useEffect(() => {
        async function loadTeam() {
            try {
                const { borrower_contacts = [] } = await apiRequest(
                    "/supabase/borrower_contacts/select"
                );
                setContacts(borrower_contacts || []);
            } catch (err) {
                console.error(err);
            }
        }
        loadTeam();
    }, []);

    return (
        <WidgetBox title="Your Contacts">
            <UnorderedList listStyleType="none" p="0px" m="0px">
                {contacts.length > 0 ? (
                    contacts.map((contact: any) => (
                        <ListItem key={contact.id} py="16px">
                            <Flex alignItems="center">
                                <UserAvatar
                                    size="50px"
                                    mr="14px"
                                    user={contact}
                                />
                                <Flex flexDir="column" flexGrow="1">
                                    <Text
                                        color="#171B1E"
                                        fontWeight="600"
                                        fontSize="15px"
                                        lineHeight="22px"
                                    >
                                        {contact.first_name} {contact.last_name}
                                    </Text>
                                    <Text fontSize="13px">
                                        {contact.job_title}
                                    </Text>
                                </Flex>
                                <Link to={`/messages/?user=${contact.id}`}>
                                    <IconButton
                                        width="40px"
                                        height="40px"
                                        background="gray.50"
                                        borderRadius="50%"
                                        color="primary"
                                        borderWidth="0px"
                                        border={"1px solid #D4D4D4"}
                                        aria-label="message-team"
                                        _hover={{
                                            background: "#E0E0E0",
                                        }}
                                        icon={
                                            <FontAwesomeIcon
                                                icon={["fas", "message"]}
                                            />
                                        }
                                    />
                                </Link>
                            </Flex>
                        </ListItem>
                    ))
                ) : (
                    <Text>No contacts found</Text>
                )}
            </UnorderedList>
        </WidgetBox>
    );
};
export default YourTeam;
